export enum SessionStorageKey {
  Session = 'GA_SESSION_STATE.session',
  Token = 'GA_SESSION_STATE.token',
}
